import { render, staticRenderFns } from "./teacherProfile.vue?vue&type=template&id=fe39ad10&"
import script from "./teacherProfile.vue?vue&type=script&lang=js&"
export * from "./teacherProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports